<template>
  <div>
    <div
      v-if="
        (products && products.length > 0) ||
        (subCategories && subCategories.length > 0)
      "
    >
      <div v-if="subCategories && subCategories.length > 0">
        <div
          v-for="subCategory in subCategories"
          :key="subCategory.id"
          class="bg-white shadow flex flex-col px-4 py-6 mb-6"
          style="border-radius: 10px; padding: 0"
        >
          <div class="row">
            <h5 class="subcategory">{{ subCategory.title }}</h5>
            <div class="flex ml-3">
              <vs-button
                @click="editSubCategory(subCategory)"
                class="flex-1 mr-1 button"
                color="primary"
                type="filled"
                size="small"
              >
                <img
                  style="width: 14px; margin-bottom: -6px"
                  src="../../../assets/icons/edit-white.svg"
                />
              </vs-button>
            </div>
          </div>
          <div class="product-cont">
            <product
              v-for="product in subCategory.items"
              :key="product.id"
              :product="product"
              :categories="categories"
              :activeCategory="activeCategory"
              :activeSubCategory="subCategory"
              @delete="$emit('delete', product, subCategory)"
              @productCategoryChanged="productCategoryChanged"
            ></product>
          </div>
        </div>
      </div>
      <template v-if="products && products.length > 0">
        <div
          class="bg-white shadow flex flex-col px-4 py-6 mb-6"
          style="border-radius: 10px; padding: 0"
        >
          <div class="product-cont">
            <product
              v-for="product in products"
              :key="product.id"
              :product="product"
              :categories="categories"
              :activeCategory="activeCategory"
              @delete="$emit('delete', product)"
              @productCategoryChanged="productCategoryChanged"
            ></product>
          </div>
        </div>
      </template>

      <vs-popup
        v-if="showEditSubCategoryPopup"
        title="ویرایش زیر دسته"
        :active.sync="showEditSubCategoryPopup"
      >
        <sub-category-input
          v-model="activeSubCategory"
          :categories="categories || []"
          @close="showEditSubCategoryPopup = false"
          :activeCategory="activeCategory"
          @delete="removeSubCategory(activeSubCategory)"
          @subCategoryUpdated="subCategoryUpdated"
        ></sub-category-input>
      </vs-popup>
    </div>
    <vs-alert v-else color="warning" icon-pack="feather" icon="icon-info">
      محصولی جهت نمایش موجود نیست
    </vs-alert>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import productApiService from "../../../services/api/ProductApiService";
  import SubCategoryInput from "../SubCategoryInput.vue";
  import Product from "./Product.vue";

  export default {
    name: "Products",
    components: { Product, SubCategoryInput },
    data() {
      return {
        showEditSubCategoryPopup: false,
        activeSubCategory: null,
        products: this.activeCategory ? this.activeCategory.items : null,
        subCategories: this.activeCategory
          ? this.activeCategory.subCategories
          : null,
        title: this.activeCategory ? this.activeCategory.title : null,
      };
    },
    computed: {
      ...mapGetters({
        currentProvider: "profile/currentProvider",
      }),
    },
    methods: {
      subCategoryUpdated(resource, category) {
        if (category.id === this.activeCategory.id) {
          const currentSubCategoryIndex = this.subCategories.findIndex(
            (element) => element.id === resource.id
          );

          this.subCategories[currentSubCategoryIndex].items =
            this.subCategories[currentSubCategoryIndex].items.map((element) => {
              return {
                ...element,
                available: +resource.available ? true : false,
              };
            });
          this.subCategories[currentSubCategoryIndex].title = resource.title;
          this.subCategories[currentSubCategoryIndex].thumbnail =
            resource.thumbnail;
          this.subCategories[currentSubCategoryIndex].level = resource.level;
          this.subCategories[currentSubCategoryIndex].visible =
            +resource.visible;
          this.subCategories[currentSubCategoryIndex].available =
            +resource.available;
          this.subCategories[currentSubCategoryIndex].description =
            resource.description;
        } else {
          this.$emit(
            "subCategoryChanged",
            resource,
            category,
            this.activeSubCategory
          );
        }
      },
      productCategoryChanged(resource, category, subCategory) {
        this.$emit("productCategoryChanged", resource, category, subCategory);
      },
      editSubCategory(subCategory) {
        this.activeSubCategory = subCategory;
        this.showEditSubCategoryPopup = true;
      },
      removeSubCategory(subCategory) {
        this.$vs.dialog({
          type: "confirm",
          color: "danger",
          title: `حذف زیر دسته`,
          text: `از حذف زیر دسته "${subCategory.title}" اطمینان دارید؟\n تمامی محصولات در این زیردسته نیز حذف خواهند شد.`,
          acceptText: "بلی",
          cancelText: "خیر",
          accept: () => {
            this.$vs.loading();
            productApiService
              .deleteCategory(this.currentProvider.id, subCategory.id)
              .then(() => {
                this.subCategories = this.subCategories.filter(
                  (item) => item.id !== subCategory.id
                );

                this.$vs.notify({
                  text: "زیر دسته با موفقیت حذف شد",
                  color: "success",
                  position: "bottom-center",
                });
              })
              .catch((err) => {
                this.$vs.notify({
                  text: err.getErrorDescriptions(),
                  color: "danger",
                  position: "bottom-center",
                });
              })
              .finally(() => {
                this.$vs.loading.close();
              });
          },
        });
      },
    },
    watch: {
      activeCategory(category) {
        this.products = category ? category.items : null;
        this.subCategories = category ? category.subCategories : null;
      },
    },
    props: {
      categories: {
        type: Array,
        required: true,
      },
      activeCategory: {
        type: Object,
        required: true,
      },
    },
  };
</script>

<style scoped lang="scss">
  .row {
    justify-content: space-between;
    display: flex;
    flex-direction: row;
    margin-bottom: 16px;

    @media (max-width: 430px) {
      margin-bottom: 24px;
    }
  }

  .button {
    width: 24px !important;
    height: 24px !important;
    padding: 4px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .product-cont {
    display: grid;
    grid-template-columns: repeat(auto-fill, var(--card-width));
    justify-content: start;
    gap: 16px;

    @media (max-width: 375px) {
      --card-width: 145px;
      justify-content: space-between;
      gap: 8px;
    }

    @media (min-width: 376px) and (max-width: 400px) {
      --card-width: 155px;
      justify-content: space-between;
      gap: 8px;
    }
    @media (min-width: 401px) and (max-width: 420px) {
      --card-width: 155px;
      justify-content: space-between;
      gap: 8px;
    }

    @media (min-width: 421px) and (max-width: 765px) {
      --card-width: 160px;
      justify-content: space-between;
      gap: 8px;
    }

    @media (min-width: 766px) {
      --card-width: 170px;
    }
  }

  .subcategory {
    font-size: 14px;
  }
</style>
